// extracted by mini-css-extract-plugin
export default {"card":"CellEvent_card__VGhTJ","active":"CellEvent_active__ERsjG","alarm":"CellEvent_alarm__dvMzO","malfunction":"CellEvent_malfunction__WjI3N","disabled":"CellEvent_disabled__iK4rk"};